module.exports = __webpack_public_path__ + "static/media/SWSCRC1-15.b2bd47ac.mp3";